import Evented from '../Evented'
import ISubscriptionConfig from '../interfaces/ISubscriptionConfig'
import ITransport from '../interfaces/ITransport'
import RequestLoop from './RequestLoop'

export default class LongPollTransport extends Evented implements ITransport {
  private lastMessageSequence = 0
  private loop?: RequestLoop
  private uri: string
  private options: ISubscriptionConfig

  get didSuccessfullyConnect () { return !!this.loop && this.loop.didSuccessfullyConnect }

  constructor (channelPath: string, options: ISubscriptionConfig) {
    super()

    this.uri = `${options.ssl ? 'https' : 'http'}:${options.host}${channelPath}`
    this.options = options
  }

  public start () {
    this.loop = new RequestLoop(this.uri, this.lastMessageSequence, this.options)

    this.listenTo(this.loop, 'message', (message, frame) => this.emit('message', message, frame))
    this.listenTo(this.loop, 'connected', (type) => this.emit('connected', type))
    this.listenTo(this.loop, 'up', () => this.emit('up'))
    this.listenTo(this.loop, 'down', () => this.emit('down'))
    this.listenTo(this.loop, 'heartbeat', () => this.emit('heartbeat'))
    this.listenTo(this.loop, 'reconnecting', () => this.emit('reconnecting'))
    this.listenTo(this.loop, 'failed', (type, frame) => this.emit('failed', type, frame))
  }

  public stop () {
    if (this.loop) {
      this.lastMessageSequence = this.loop.lastMessageSequence
      this.loop.stop()
      this.stopListening(this.loop)
      delete this.loop
    }
  }
}
